var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 64,
    viewBox: "0 0 26 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.34027 17.9154C7.91267 18.1514 7.20072 18.4469 6.20229 18.802C5.20171 19.157 4.44273 19.4291 3.92106 19.6183C1.82797 20.2774 0.521668 20.7515 0 21.0342V12.8833C1.61418 12.22 3.57471 11.2633 5.88159 10.009C8.18633 8.75891 9.81334 7.61089 10.7647 6.57129H19.3915V63.9999H8.34027V17.9154Z",
    fill: "#8DC73F",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9053 59.6035H13.854C13.2511 59.6035 12.7594 59.1145 12.7594 58.515V14.0951C12.5499 14.1738 12.3254 14.2567 12.0817 14.3417L9.80684 15.156C7.12795 16.0021 6.29628 16.3635 6.03331 16.506C5.69551 16.6931 5.28501 16.6803 4.95149 16.4847C4.6201 16.2891 4.41699 15.9341 4.41699 15.5514V7.40048C4.41699 6.9604 4.68424 6.56285 5.09259 6.3949C6.66615 5.74648 8.61171 4.7983 10.8673 3.57162C13.048 2.38746 14.5959 1.30747 15.4639 0.355036C15.6735 0.129684 15.9642 0 16.2742 0H24.901C25.5039 0 25.9956 0.488972 25.9956 1.08849V58.5171C25.9956 59.1167 25.506 59.6056 24.901 59.6056L24.9053 59.6035ZM14.9487 57.4286H23.8128V2.17699H16.7446C15.682 3.21446 14.0978 4.30082 11.9192 5.48286C9.90305 6.57986 8.12212 7.46426 6.60842 8.12118V13.9272C7.20065 13.7146 8.00453 13.4446 9.10345 13.0981L11.3505 12.2944C12.5199 11.8778 13.0694 11.6226 13.3238 11.4802C13.6638 11.291 14.0764 11.2952 14.4121 11.493C14.7456 11.6885 14.9508 12.0457 14.9508 12.4305V57.4265L14.9487 57.4286Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.8947d760d97926e98889a6590020e49e.svg";
export { ForwardRef as ReactComponent };